/*------------------------------------*
    IMPORTS
\*------------------------------------*/
import TypeMate from 'typemate';
import Bugsnag from "@bugsnag/js";

import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/collapse';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.bind();
    },

    bind() {
        const context = require.context('./modules', false, /\.js$/);

        const moduleRegistry = {};

        context.keys().forEach((key) => {
            const mod = context(key).default;

            const fileName = key.replace(/^.\//, '').replace(/\.js$/, '');

            const pascalCaseName = fileName
                .split('-')
                .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
                .join('');

            moduleRegistry[pascalCaseName] = mod;
        });
        
        const kebabToPascal = (str) =>
            str.split('-')
                .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
                .join('');
        
        const modulePlaceholders = [...document.querySelectorAll('[data-module]')];

        if (!modulePlaceholders.length) return;

        modulePlaceholders.forEach((item) => {
            const modulesAttr = item.getAttribute('data-module');
            if (!modulesAttr) return;

            const modules = modulesAttr.trim().split(',');

            modules.forEach((moduleName) => {
                const pascalCaseName = kebabToPascal(moduleName.trim());

                const ModuleClass = moduleRegistry[pascalCaseName];

                if (typeof ModuleClass === 'function') {
                    const instance = new ModuleClass(item);
                    if (typeof instance.init === 'function') {
                        instance.init();
                    }
                } else {
                    console.warn(`Module "${pascalCaseName}" not found.`);
                }
            });
        });
    },

    alwaysLoad() {
        // Typemate
        const ignoreClasses = [
            'ignore-typemate',
        ];
        const typeMateInstance = new TypeMate(document.body, { ignoreClasses });
        typeMateInstance.apply();

        // Bugsnag
        if (process.env.FRONT_END_BUGSNAG_KEY) {
            Bugsnag.start({
                apiKey: process.env.FRONT_END_BUGSNAG_KEY,
                releaseStage: process.env.CRAFT_ENVIRONMENT,
            });
        }
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    }
};

// Launch
app.init();